/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-DUAqv8gi.js";
import "./assistant-specialist-pill-Ctzyik3U.js";
import { t } from "./reduced-motion.css-tEHc8kYn.js";
import { t as n } from "./css-build-DcREbovZ.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o } from "lit";
import { customElement as s, property as c } from "lit/decorators.js";
import { repeat as l } from "lit/directives/repeat.js";
// \0lit-plugin:css-sheet:./src/elements/assistant/assistant-specialists-bar/assistant-specialists-bar.css.js
var u = n(":host{pointer-events:none}.specialists-bar{z-index:1;flex-flow:wrap;justify-content:center;align-items:center;gap:.2rem;width:100%;margin:0;padding:.2rem;font-size:.6rem;list-style:none;transition:transform .3s ease-in-out;display:flex;inset:0 0 auto}.specialists-bar[aria-busy=false]{transform:translateY(-100%)}.specialists-bar[aria-busy=true]{transition-delay:.3s;transform:none}"), d = class extends e(a) {
	constructor(...e) {
		super(...e), this.styles = [u, t], this.specialists = [], this.metadata = {}, this._handlePillDone = (e) => {
			let t = e.composedPath()[0];
			document.startViewTransition ? document.startViewTransition(() => t.remove()) : t.remove();
		};
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("pill-done", this._handlePillDone);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener("pill-done", this._handlePillDone);
	}
	render() {
		let e = this.specialists.some((e) => e.status === "running");
		return o`
            <ul class="specialists-bar" aria-busy="${e ? "true" : "false"}">
                ${l(this.specialists, (e) => e.id, (e) => {
			let t = this.metadata[e.kind] ?? this.fallback;
			return o`
                            <ptc-ui-assistant-specialist-pill
                                status="${e.status}"
                                label="${t?.label ?? ""}"
                                icon="${t?.icon ?? ""}"
                                color="${t?.color ?? ""}"
                                data-id="${e.id}"
                                style="view-transition-name: specialist-${e.id}"
                            ></ptc-ui-assistant-specialist-pill>
                        `;
		})}
            </ul>
        `;
	}
};
i([c({ type: Array }), r("design:type", Array)], d.prototype, "specialists", void 0), i([c({ type: Object }), r("design:type", typeof Record > "u" ? Object : Record)], d.prototype, "metadata", void 0), i([c({ type: Object }), r("design:type", Object)], d.prototype, "fallback", void 0), d = i([s("ptc-ui-assistant-specialists-bar")], d);
export { d as t };

//# sourceMappingURL=assistant-specialists-bar-gtBOAEEG.js.map